module.exports = __webpack_public_path__ + "static/media/ehealth_ehr_lite_banner_mobile.b99411f7.jpg";